import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { error } from 'react-notification-system-redux';
import { useDashboardAPI } from '../../../hooks';
import { notificationsConfig } from '../../../config/constants';
export const useFarmListQuery = (options) => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        ...options,
        queryFn: () => api.farms.getFarms(),
        queryKey: ['farms'],
        select: (data) => (Array.isArray(data) ? data : []),
    });
};
//# sourceMappingURL=useFarmListQuery.js.map